
<template>
  <div class="exercise centered-box locations-white locations-generic">
    <div class="locations-title">Exercise Class (four sessions; one session per week)</div>We've been selling out this guided event for 17 years. Until recently, we had been calling it our Cardio Kayak Class but learned that this name was off putting to potential customers who wanted to paddle, but were worried that it might be some sort of on-the-water boot camp.<br><br>
Fear not, whatever your experience and fitness level, you'll be able to tailor your exercise sessions to suit your needs. Want to go hell-for-leather and clock up four or five miles? Go for it. Want to decompress after a hard day's work, paddle at a leisurely pace, and enjoy the birds and animals you'll likely see along the way? We'll make that happen.<br><br> 
The initial session will include a safety talk and basic lesson. We'll give you an on-land primer, including a run through of basic paddling techniques. We'll then get on the water to practice and hone those techniques.<br><br> 
 <h5>Session duration:</h5> 80 minutes <br><br>
<h5>Price:</h5> $100 (returning customers, $70)<br><br>
</div>
</template>

<script>
export default { 
  name: "Exercise",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.exercise {
color: black;
margin-left: 20px;
margin-right: 20px;
}
</style>
